import { AfterViewInit, Component, ElementRef, HostListener, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController, ViewWillEnter } from '@ionic/angular';
import { KeyboardKeysEnum } from '../../enums/keyboard-keys.enum';
import { ModalRoleEnum } from '../../enums/modal-role.enum';
import { MetodosModal } from '../../interfaces/metodos-modal.interface';
import { EnderecoPessoa, PessoaModel } from '../../models/pessoa.model';
import { HelpersUtil } from '../../utils/helpers.util';
import { PessoaService } from 'src/app/core/services/http/pessoa.service';
import { DialogStateUtil } from '../../utils/dialog-state.util';

@Component({
    selector: 'app-cadastro-clientes',
    templateUrl: './cadastro-clientes.component.html',
    styleUrls: ['./cadastro-clientes.component.scss'],
})
export class CadastroClientesComponent implements ViewWillEnter, MetodosModal {
    public cliente: PessoaModel = new PessoaModel();

    telaPequena = false;

    public form: FormGroup = this.fb.group({
        nome: ['', [Validators.required, Validators.minLength(2)]],
        endereco: ['', []],
        numero: ['', []],
        pontoReferencia: ['', []],
        bairro: ['', []],
        celular1: ['', []],
        celular2: ['', []],
    });
    public novoEndereco = new EnderecoPessoa();

    constructor(
        private modalCtrl: ModalController,
        private fb: FormBuilder,
        private pessoaService: PessoaService,
        private elementRef: ElementRef
    ) { }

    public GravarEndereco(endereco: EnderecoPessoa) {
        const registroNovo = endereco.codigo == 0;
        endereco.codPessoa = this.cliente.codigo;

        this.pessoaService.AddOrUpdateEndereco(endereco).subscribe(dataR => {
            if (dataR.success) {
                const ObjEnderecoVM = HelpersUtil.CopyObject(dataR.data, new EnderecoPessoa());
                this.novoEndereco = new EnderecoPessoa();

                if (registroNovo) {
                    this.cliente.enderecos.push(ObjEnderecoVM);
                }
                else {
                    var i = this.cliente.enderecos.findIndex(l => l.codigo == endereco.codigo);
                    this.cliente.enderecos[i] = ObjEnderecoVM;
                    this.cliente.enderecos[i].getEnderecoCompleto();
                }
            }
        })
    }

    public async cancel() {
        await this.modalCtrl.dismiss(null, ModalRoleEnum.CANCEL);

        DialogStateUtil.dialogIsClosed();
    }

    public async confirm() {
        const formValue = this.form.value;

        this.cliente = {
            ...this.cliente,
            ...formValue,
            celulares: [
                formValue.celular1,
                formValue.celular2
            ]
        };

        const dataClose = new CadastroClientesDataClose(this.cliente);

        await this.modalCtrl.dismiss(dataClose, ModalRoleEnum.CONFIRM);

        DialogStateUtil.dialogIsClosed();
    }

    public ionViewWillEnter(): void {
        this.cliente.enderecos = [];

        this.form.patchValue({
            nome: this.cliente.nome,
            endereco: this.cliente.endereco,
            numero: this.cliente.numero,
            pontoReferencia: this.cliente.pontoReferencia,
            bairro: this.cliente.bairro,
            celular1: this.cliente.celulares?.[0] ?? '',
            celular2: this.cliente.celulares?.[1] ?? ''
        });

        this.form.valueChanges.subscribe(v => {
            this.cliente = {
                ...this.cliente,
                ...v,
                celulares: [
                    v.celular1,
                    v.celular2
                ]
            };
        });


        if (this.cliente) {

            if (this.cliente.codigo > 0) {
                this.pessoaService.getAllEnderecos(this.cliente.codigo).subscribe(dataR => {
                    if (dataR.success)
                        (dataR.data.filter(l => l.codigo > 0)).forEach(l => {
                            const ObjEnderecoVM = HelpersUtil.CopyObject(l, new EnderecoPessoa());
                            this.cliente.enderecos.push(ObjEnderecoVM);
                        });

                });
            }

        }

        this.telaPequena = window.innerWidth < 1400;
    }

    public onAccordionChange(): void {
        HelpersUtil.executeAfterDelay(() => {
            const accordionExpandido = document.getElementsByClassName('accordion-expanded')[0];
            accordionExpandido.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
    }

    @HostListener('window:keydown', ['$event'])
    public async handleKeyboardEvent(event: KeyboardEvent): Promise<void> {
        switch (event.key) {
            case KeyboardKeysEnum.F5:
                this.handleF5Key();
                break;
        }
    }

    private handleF5Key() {
        this.confirm();
    }

    public proximoFocoInput(next: any) {
        if (next && next.focus) {
            next.focus();
        }
    }

    private splitEndereco(endereco: string): EnderecoSplit {
        if (!endereco) return { rua: '', numero: '', bairro: '', pontoReferencia: '', celular: '' };

        const partes = endereco.split(',').map(x => x.trim());

        return {
            rua: partes[0] ?? '',
            numero: partes[1] ?? '',
            bairro: partes[2] ?? '',
            pontoReferencia: partes[3] ?? '',
            celular: partes[4] ?? '',
        };
    }

    public formatarEndereco(endereco: string) {
        const split = this.splitEndereco(endereco);

        const valores = this.mergeEndereco(this.form.value, split);

        this.aplicarNoForm(valores);
        this.aplicarNoCliente(valores);
    }

    private aplicarNoCliente(valores: any) {
        this.cliente.endereco = valores.endereco;
        this.cliente.numero = valores.numero;
        this.cliente.bairro = valores.bairro;
        this.cliente.pontoReferencia = valores.pontoReferencia;
        this.cliente.celulares[0] = valores.celular1;
    }

    private aplicarNoForm(valores: any) {
        this.form.patchValue(valores);
    }

    private mergeEndereco(atual: any, split: EnderecoSplit) {
        return {
            endereco: split.rua || atual.endereco,
            numero: split.numero || atual.numero,
            bairro: split.bairro || atual.bairro,
            pontoReferencia: split.pontoReferencia || atual.pontoReferencia,
            celular1: split.celular || atual.celular1,
        };
    }
}

export interface EnderecoSplit {
    rua: string,
    numero: string,
    bairro: string,
    pontoReferencia: string,
    celular: string,
}

export class CadastroClientesDataClose {
    constructor(public cliente: PessoaModel) { }
}
